import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { environment } from '@app/environment';
import { TranslateService } from '@ngx-translate/core';

/** "Enlitic · HC - HCIT · Hunter": the page or entity first, the app last. */
export const toDocumentTitle = (
  parts: (string | null | undefined)[],
  appName = environment.branding.appName
) => [...parts.filter((part) => !!part?.trim()), appName].join(' · ');

/** Sets the document title; pages of an entity set it once it is loaded. */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private title = inject(Title);

  setTitle(...parts: (string | null | undefined)[]) {
    this.title.setTitle(toDocumentTitle(parts));
  }
}

/**
 * The title of routes with a `title` (a translation key). Routes without one
 * are pages of an entity (a list, a company), which set the title themselves
 * through PageTitleService.
 */
@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private pageTitle = inject(PageTitleService);
  private translate = inject(TranslateService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const key = this.buildTitle(snapshot);
    if (key) {
      this.translate
        .get(key)
        .subscribe((text: string) => this.pageTitle.setTitle(text));
    }
  }
}
